import { Controller } from "@hotwired/stimulus"

let deferredPrompt = null
window.addEventListener("beforeinstallprompt", event => {
  event.preventDefault()
  deferredPrompt = event
})
// window.addEventListener("appinstalled", () => {
//   console.log("app installed")
// })

// Connects to data-controller="pwa-install-trigger"
export default class extends Controller {
  promptInstall() {
    deferredPrompt?.prompt()
    deferredPrompt = null // can only use once
  }
}
